<template>
  <div class="left-wrapper">
    <header class="leftbar">
      <div class="leftbar__inner scroll-box">
        <!-- <div
          class="d-flex flex-row sm:hidden xl:flex sm:flex-col w-full justify-around items-center mb-2"
          :class="{ 'pt-[18px]': !user }"
          v-if="!isUserAuth">
          <div class="leftbar__items">
            <router-link to="/about" class="leftbar__overlay-item text-foregroundPrimary">
              <ChannelIcon class="mr-2 w-[20px]" />
              About Us
            </router-link>
          </div>
          <BaseButton class="max-w-[100px] sign-in-button" @click="logIn">Sign in</BaseButton>
          <BaseButton class="max-w-[100px] sign-up-button" @click="signUp">Sign up</BaseButton>
          <SIWFButton style="margin-top: 10px" class="sign-up-button" width="105px" buttonText="SIWF" @click="siwf" />
        </div> -->
        <BaseButton class="w-full mb-2" @click="openCreatePost">
          <CreatePostIcon />
        </BaseButton>
        <!-- remove profile civic score for now -->
        <!-- <ProfileCivicCard :user="userdata" /> -->

        <FollowedGroups :groupsData="localOrgs" class="mb-2" />
        <QuickLinks @link-click="handleClick" />
        <!-- this code was for web -->
        <!-- <div v-if="isUserAuth && userdata && !isMobile"
          class="leftbar__nav w-full mt-6 hidden sm:flex justify-start flex-col items-start">
          <div v-for="links in navLinks.filter(el => !el.hidden)" :key="links.name"
            @click.prevent="toggleLink(links, links.id)" :class="{ 'min-[1025px]:hidden': links.name === 'Explore' }">
            <component :is="links.name === 'Post' ? 'div' : 'router-link'"
              :to="links.name !== 'Post' ? getLink(links) : undefined" class="leftbar__items flex mb-[20px]" :class="{
                'pointer-events-none': links.disabled,
                active: links.isActive,
                full__size: isFullMenuItems,
                'create-button': links.name === 'Post',
              }" @click="links.name === 'Post'">
              <div class="flex justify-center items-start" :class="{ 'ml-[16px]': links.name !== 'Post' }">
                <div class="w-[20px] h-[20px] relative">
                  <img :src="getIconPath(links).value" alt="icon"
                    :class="{ 'bell-shake': links.id === 4 && isShaking }" />
                  <span v-if="links.id === 4 && unreadNotificationsCount > 0"
                    class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1 text-[10px]">
                    {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
                  </span>
                </div>
                <span class="leftbar__label text-foregroundPrimary text-[16px] cursor-pointer" :class="{
                  'mt-1': links.name === 'Home',
                  'hidden xl:block': !isFullMenuItems,
                  'd-block': isFullMenuItems,
                  'font-weight': links.isActive,
                  'create-label': links.name === 'Post',
                }">{{ links.name }}</span>
                <div v-if="links.id === 5"
                  class="bg-[var(--interactive-01,#a3e635)] text-[var(--button-on-primary,#000)] p-1 text-[12px] rounded-[5px] ml-1 -mt-[1px] max-h-[15px] flex items-center">
                  <span>Beta</span>
                </div>
              </div>
            </component>
          </div>
        </div> -->
        <!-- this is old code and for mobile screen these are the buttons -->
        <!-- <div v-if="userdata && isMobile"
          class="leftbar__nav w-full mt-[12px] mb-[10px] flex sm:hidden justify-between items-center">
          <div v-for="links in navLinks.filter(el => !el.hiddenForMobile)" :key="links.name"
            @click.prevent="toggleLink(links, links.id)">
            <div v-if="links.name === 'Post'"
              class="leftbar__items flex content-center items-center create-button-mobile"
              :class="{ active: links.isActive }">
              <img class="cursor-pointer" :src="getIconPath(links).value" alt="icon" />
            </div>
            <router-link v-else :to="links.src" class="leftbar__items flex content-center items-center relative"
              :class="{ 'pointer-events-none': links.disabled, active: links.isActive }">
              <div class="relative">
                <img class="cursor-pointer" :src="getIconPath(links).value" alt="icon"
                  :class="{ 'bell-shake': links.id === 4 && isShaking }" />
                <span v-if="links.id === 4 && unreadNotificationsCount > 0"
                  class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1 text-[10px]">
                  {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
                </span>
              </div>
              <div v-if="links.id === 5"
                class="bg-[var(--interactive-01,#a3e635)] text-[var(--button-on-primary,#000)] p-[2px] text-[10px] rounded-[4px] absolute -top-1 right-1 flex items-center">
                <span>Beta</span>
              </div>
            </router-link>
          </div>

          <div class="flex justify-center items-center cursor-pointer relative">
            <button class="leftbar__items leftbar__items-mobile h-[24px] text-foregroundPrimary"
              @click.stop="toggleLeftbarOverlay" aria-haspopup="menu"
              :aria-expanded="isLeftbarOverlayVisible.toString()" aria-controls="mobile-utility-menu"
              id="mobile-menu-toggle" title="Menu">
              <MenuIcon />
            </button>

            <div v-show="isLeftbarOverlayVisible" @click="closeLeftbarOverlay"
              class="leftbar__overlay flex flex-col text-sm" id="mobile-utility-menu" role="menu" tabindex="-1"
              aria-labelledby="mobile-menu-toggle" ref="overlayEl" @keydown.esc.stop.prevent="closeLeftbarOverlay">

              <RouterLink to="/about" class="leftbar__overlay-item" role="menuitem">
                <ChannelIcon class="mr-2 w-[20px]" />
                About Us
              </RouterLink>
              <RouterLink to="/user/sezushelp" class="leftbar__overlay-item" role="menuitem">
                <lightBulbIcon class="mr-2 w-[20px]" />
                Help
              </RouterLink>
            </div>
          </div>
        </div> -->
      </div>
    </header>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch, watchEffect, nextTick } from 'vue';

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ChannelIcon from '@/components/Icons/ChannelIcon.vue';
import LightBulbIcon from '@/components/Icons/LightBulbIcon.vue';
import MenuIcon from '@/components/Icons/MenuIcon.vue';
import AboutUsLink from '@/components/Leftbar/AboutUsLink.vue';
import SIWFButton from '@/components/ui-kit/SIWFButton/index.vue';
import { environment } from '@/global/baseUrls.js';
import { setDefaultTab } from '@/utils/activeTabUtils';
import { useSchemeObserver } from '@/utils/colorSchemeUtils.js';
import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollControl';
import ProfileCivicCard from "../ui-kit/ProfileCivicCard/index.vue";
import CreatePostIcon from '@/components/Icons/CreatePostIcon.vue';
import FollowedGroups from '@/components/ui-kit/FollowedGroups/index.vue';
import QuickLinks from "@/components/ui-kit/QuickLinks/index.vue";
import { mapGetters } from 'vuex';
const store = useStore();
const router = useRouter();
const route = useRoute();
const currentScheme = useSchemeObserver();
// const userDetails = computed(() => store.getters.getUser);
// console.log(userDetails, "user");
const isLinkActive = link => {
  const path = route.fullPath;

  if (link.name === 'Home' && path === '/') return true;
  if (link.name === 'Explore' && path.startsWith('/search')) return true;
  if (link.name === 'Notifications' && path.startsWith('/notifications')) return true;
  if (link.name === 'Help' && path.includes('/user/sezushelp')) return true;
  if (link.name === 'About Us' && path.startsWith('/about')) return true;
  // Accept both new and legacy groups patterns
  if (link.name === 'Groups' && path.startsWith('/groups')) return true;

  return false;
};


const handleClick = (link) => {
  console.log("Clicked link:", link);
  // You can navigate or do anything here
};

const logOut = payload => store.dispatch('logOut', payload);

//const getOnlyUserPosts = (payload) => store.dispatch("setOnlyUserPosts", { id: payload, limit: "1" });
const setShowModal = value => store.dispatch('showModal', value);
const setEditData = data => store.dispatch('addModalDataToState', data);
const setIsReply = value => store.dispatch('setIsReply', value);
const user = localStorage.getItem('user');
const isShowModal = computed(() => store.getters.getShowModalStatus);
const isUserAuth = computed(() => store.getters.getAuthStatus);
const userdata = computed(() => store.getters.getUser);
console.error("Leftbar userdata:", userdata.value);
const environments = ref(['https://dev.sez.us', 'https://stg.sez.us', 'https://sez.us']);
const isFullMenuItems = ref(false);
const localOrgs = ref([]);
const myOrgs = computed(() => store.getters.getOnlyUserOrgs);
console.error("user name", myOrgs)
const unreadNotificationsCount = computed(() => store.getters.getUnreadNotificationsCount);
const isShaking = ref(false);
// const followedGroups = ref([]);
// Track mobile breakpoint to avoid rendering both desktop and mobile navs simultaneously
const isMobile = ref(false);
const updateIsMobile = () => {
  // Match the sm breakpoint (~640px); use same logic as CSS where mobile nav shows below sm
  isMobile.value = window.innerWidth < 640;
};
const userId = JSON.parse(localStorage.getItem('user'))?.id;
onMounted(async () => {
  if (userId) {
    await store.dispatch('channels/fetchChannelsList', {
      ownerId: userId,
      ownerType: 'user',
    });
  }
});
onMounted(() => {
  store.dispatch("fetchOnlyUserOrgs"); // Fetch logged-in user's orgs
});
// 3. Get channel list from Vuex
const followedGroups = computed(() => store.getters['channels/getChannelsList']);

console.log("Leftbar followedGroups:", followedGroups.value);
onMounted(() => {
  updateIsMobile();
  window.addEventListener('resize', updateIsMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', updateIsMobile);
});
watch(
  () => store.getters.getOnlyUserOrgs,
  (newVal) => {

    if (Array.isArray(newVal)) {
      localOrgs.value = newVal;
    }
  },
  { immediate: true }
);
// Trigger shake animation
const triggerShake = () => {
  isShaking.value = true;
  setTimeout(() => {
    isShaking.value = false;
  }, 500);
};

const userRoute = computed(() => {
  return `/user/sezushelp`;
});

const navLinks = ref([
  {
    icon: 'Home.svg',
    id: 1,
    iconActive: 'Homefill.svg',
    name: 'Home',
    src: '/',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    icon: 'Search.svg',
    iconActive: 'Search.svg',
    name: 'Explore',
    id: 2,
    src: '/search',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    id: 3,
    icon: 'Channel.svg',
    iconActive: 'Channel.svg',
    name: 'About Us',
    src: '/about',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 4,
    icon: 'Alert.svg',
    iconActive: 'Alertfill.svg',
    name: 'Notifications',
    src: '/notifications',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 5,
    icon: 'Groups.svg',
    iconActive: 'Groupsfill.svg',
    name: 'Groups',
    src: '/groups', // Use the standard /groups route instead of /orgs-groups
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    id: 6,
    icon: 'lightbulb.svg',
    iconActive: 'lightbulb.svg',
    name: 'Help',
    src: userRoute, // Back to pointing to /user/sezushelp
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 7,
    icon: 'Create.svg',
    iconActive: 'Create.svg',
    name: 'Post',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
]);

const getIconPath = link => {
  return computed(() => {
    const scheme = currentScheme.value;
    if (link.name === 'Post') {
      // For the Create button, always use the dark icon, since the button background is light
      return `/icon/Create-dark.svg`;
    }

    // Special handling for notifications
    if (link.id === 4) {
      const hasMessages = unreadNotificationsCount.value > 0;
      if (link.isActive) {
        return hasMessages
          ? `/icon/alert-unread-fill${scheme === 'light' ? '-dark' : ''}.svg`
          : `/icon/Alertfill${scheme === 'light' ? '-dark' : ''}.svg`;
      } else {
        return hasMessages
          ? `/icon/alert-unread${scheme === 'light' ? '-dark' : ''}.svg`
          : `/icon/Alert${scheme === 'light' ? '-dark' : ''}.svg`;
      }
    }

    return link.isActive
      ? `/icon/${link.iconActive.replace('.svg', scheme === 'light' ? '-dark.svg' : '.svg')}`
      : `/icon/${link.icon.replace('.svg', scheme === 'light' ? '-dark.svg' : '.svg')}`;
  });
};

const getLink = link => {
  if (!link.src) return;
  return link.src;
};

watch(
  unreadNotificationsCount,
  (newCount, oldCount) => {
    // Only shake if count increased (new notification arrived)
    if (newCount > oldCount && oldCount !== undefined) {
      triggerShake();
    }
  },
  { immediate: true },
);

onMounted(() => {
  navLinks.value.forEach(link => {
    link.isActive = isLinkActive(link);
  });
  // Removed legacy encoded user ID logic for Groups link
});
// group suggestion api on moount of leftbar
// jab Leftbar mount ho

onMounted(async () => {
  const userId = JSON.parse(localStorage.getItem('user'))?.id;
  if (userId) {
    await store.dispatch('channels/fetchChannelsList', {
      ownerId: userId,
      ownerType: 'user',
    });
  } else {
    console.warn('User ID not found in localStorage');
  }
});
watch(() => userdata.value?.id, (newId) => {
  // Removed legacy encoded user ID logic for Groups link
});

// Watch for user authentication to shake on login if notifications exist
watch(
  () => userdata.value,
  (newUser, oldUser) => {
    // Trigger shake when user logs in and has unread notifications
    if (newUser && !oldUser && unreadNotificationsCount.value > 0) {
      // Delay slightly to ensure UI is ready
      setTimeout(() => {
        triggerShake();
      }, 1000);
    }
  }
);

watchEffect(() => {
  if (!isShowModal.value) {
    const createButton = navLinks.value.find(el => el.name === 'Post');
    if (createButton) createButton.isActive = false;

    // After closing the modal, restore the active state for the current route
    navLinks.value.forEach(link => {
      if (link.name !== 'Post') {
        link.isActive = isLinkActive(link);
      }
    });
  }
});

const toggleLink = async (item, id) => {
  // Enable animation immediately on click
  isFullMenuItems.value = true;

  // Any asynchronous actions after that
  if (item.name === 'Home') {
    eventBus.emit('set-default-tab');
    setTimeout(() => {
      scrollToTop();
    }, 100);
  }

  navLinks.value.forEach(el => (el.isActive = false));
  item.isActive = true;

  if (item.name === 'Post') {
    if (userdata.value) {
      store.dispatch('fetchCurrentProfileOrg', userdata.value);
    } else {
      store.dispatch('fetchCurrentProfileOrg', null);
    }
    // Open modal immediately; refresh user state in background
    setIsReply(false);
    setEditData(null);
    setShowModal(true);
    store.dispatch('getMe').catch(() => { });
    return;
  }
};
const openCreatePost = () => {
  setIsReply(false);
  setEditData(null);
  setShowModal(true);
  store.dispatch('getMe').catch(() => { });
};

const logIn = () => {
  router.push('/sign-in');
  localStorage.removeItem('activeTab');
};
const signUp = () => {
  router.push('/onboarding/login-method');
};

const togglelogOut = () => {
  logOut();
};

const isLeftbarOverlayVisible = ref(false);
const overlayEl = ref(null);
const toggleLeftbarOverlay = () => {
  isLeftbarOverlayVisible.value = !isLeftbarOverlayVisible.value;
  if (isLeftbarOverlayVisible.value) {
    nextTick(() => {
      try {
        overlayEl.value?.focus?.();
      } catch { }
    });
  }
};
const closeLeftbarOverlay = () => {
  isLeftbarOverlayVisible.value = false;
};
const closeLeftbarOverlayOnOutsideClick = event => {
  if (!event.target.closest('.leftbar__overlay')) {
    isLeftbarOverlayVisible.value = false;
  }
};
onMounted(() => {
  document.addEventListener('click', closeLeftbarOverlayOnOutsideClick);
});
onUnmounted(() => {
  document.removeEventListener('click', closeLeftbarOverlayOnOutsideClick);
});

</script>

<style lang="scss" scoped>
.leftbar__items {
  width: 60px;
  height: 40px;
  position: relative;
  z-index: 1;

  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;

  &.active {
    opacity: var(--leftbar-menu-hover-opacity);
  }

  &.full__size {
    width: 160px;
  }

  &:hover {
    opacity: var(--leftbar-menu-hover-opacity);
  }
}

.leftbar__items-mobile {
  display: flex;
  align-items: center !important;
  justify-content: center;
}

.leftbar__label {
  margin-left: 10px;
  font-weight: 400;
}

.leftbar {
  width: 100%;
  height: 100%;

  position: sticky;
  top: 0;
  /* container has top padding equal to header height */
  // width: var(--leftbar-width);
  transition: width 0.2s ease;
  overflow: hidden;
  /* Ensure Leftbar stays visually above center content at all breakpoints */
  z-index: var(--z-index-sticky, 1100);

  &__inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    // justify-content: flex-start;
    // align-items: flex-start;
    position: sticky;
    top: 0;
    /* container has top padding equal to header height */
    width: 100%;
    height: 86vh;
    border-radius: 10px;

    // @include container;
  }

  .scroll-box {
    overflow-y: scroll;
    /* enables scroll functionality */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* Internet Explorer and Edge */
  }

  .scroll-box::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
  }

  /* Responsive behavior for labels */
  .leftbar__label {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  /* Hide labels when leftbar is narrow (icon-only mode) */
  @media (max-width: 700px) {
    .leftbar__label {
      opacity: 0;
      width: 0;
      overflow: hidden;
      margin-left: 0;
    }

    .leftbar__items {
      justify-content: center;

      &.full__size {
        width: 48px;
        /* Shrink to icon size */
      }
    }
  }

  /* Further shrink on very narrow screens */
  @media (max-width: 600px) {
    .leftbar__items {
      width: 40px;
      height: 36px;

      &.full__size {
        width: 40px;
      }
    }
  }

  /* Minimal size but never hide completely - maintain icon visibility */
  @media (max-width: 400px) {
    .leftbar__items {
      width: 36px;
      height: 32px;

      &.full__size {
        width: 36px;
      }
    }
  }

  .nav-bar {
    width: 100%;
    background: transparent;

    &__inner {
      /* Declarations first to satisfy Sass mixed-decls */
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      overflow: auto;
      /* Put non-nested declarations before any nested rules */
      scrollbar-color: transparent transparent;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        background-color: transparent;
      }

      /* Nested mixins/rules after declarations */
      @include container;
    }

    &__items {
      position: relative;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      grid-gap: 5px;
    }

    &__item {
      padding: 28px 0;
      color: var(--interactive-01);
      transition: 0.2s ease-in-out;

      a {
        text-decoration: none;
      }

      span {
        display: block;
        color: var(--interactive-01);
        text-decoration: none;
        transition: 0.2s ease-in-out;
        word-break: break-words;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    &__shape {
      $tabsCount: 2;
      $pagePadding: 5px;
      margin: 0 $pagePadding;
      position: absolute;
      height: 2px;
      left: 0;
      bottom: 0;
      width: calc((100% / #{$tabsCount}) - #{$pagePadding * 2});
      background: var(--interactive-01);
      transition: 0.3s ease-in-out;
    }
  }

  &__action {
    display: flex;
  }

  &__button {
    &_left {
      margin-right: 20px;
    }
  }

  @include _1279 {
    &__inner {
      padding: 0;
    }
  }

  @include _1024 {
    &__inner {
      padding-left: 29px;
    }
  }

  @include _767 {
    position: relative;
    top: auto;
    height: auto;
  }

  @include _639 {
    position: inherit;
    bottom: 0;
    left: 0;
    width: 100%;
    /* Opaque, accessible mobile bottom bar */
    background-color: var(--app-card-bg);
    border-top: 1px solid var(--surface-border);
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    z-index: 1000;
    /* Ensure adequate touch target space, plus safe-area inset */
    min-height: var(--bottom-nav-height);
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom, 0px));
    overflow: visible;
    /* Allow overlays to escape the nav height */

    &__inner {
      padding-left: 0;
    }

    /* Normalize spacing of the inline mobile nav inside the fixed bar */
    .leftbar__nav {
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }

  @include _575 {
    &__button {
      font-size: 14px !important;
      padding: 0;
    }

    .nav-bar {
      &__item {
        padding: 15px 0;
        font-size: 12px;
      }
    }
  }
}

.leftbar__inner-active-menu {
  padding: 17px !important;
}

.leftbar__items::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0);
  z-index: -1;
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
}

.leftbar__items:hover::before {
  background-color: var(--background-secondary);
}

.leftbar__items.active::before {
  background-color: transparent;
}

.font-weight {
  font-weight: 700;
}

// .leftbar__items img,
// .leftbar__items svg {
//   width: 24px;
//   height: 24px;
// }

@media (min-width: 1280px) {

  .sign-in-button,
  .sign-up-button {
    margin-top: 15px;
  }

  .leftbar__nav {
    align-items: start;
  }

  .leftbar__items {
    width: 160px;
    height: 40px;
  }

  .create-button.leftbar__items {
    width: auto !important;
    padding: 6px 12px !important;
  }
}

@media (min-width: 1024px) and (max-width: 1279px) {

  .sign-in-button,
  .sign-up-button {
    margin-top: 5px;
  }
}

@media (max-width: 767px) {

  .sign-in-button,
  .sign-up-button {
    margin-top: 0;
  }
}

.create-button {
  margin-left: 6px;
  background-color: var(--interactive-01, #a3e635);
  border-radius: 6px;
  opacity: 1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  padding: 6px 12px;
  height: 36px;
  width: auto !important;

  &:hover {
    opacity: 0.9 !important;
    background-color: var(--interactive-01-hover, #95d130);
  }

  &::before {
    display: none;
  }

  .create-label {
    color: var(--button-on-primary, #000);
    font-weight: 500;
    margin-left: 6px !important;
  }

  img {
    filter: brightness(0);
  }

  &.full__size {
    width: auto !important;
  }
}

.create-button-mobile {
  background-color: var(--interactive-01, #a3e635);
  border-radius: 6px;
  opacity: 1 !important;
  height: 28px !important;
  width: 40px !important;
  display: flex;
  justify-content: center;
  padding: 6px;

  &:hover {
    opacity: 0.9 !important;
    background-color: var(--interactive-01-hover, #95d130);
  }

  &::before {
    display: none;
  }

  img {
    width: 18px;
    height: 18px;
    filter: brightness(0);
  }
}
</style>
<style lang="scss">
.left-wrapper {
  flex-direction: column;
  justify-content: space-between;
  // margin-top: 10rem;
  width: 20%;
  height: 100%;
  /* width: 100%; */
  // background: aqua;
  // flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    width: 40%;
  }

  @media (max-width: 576px) {
    width: 100%;
    height: auto;
    display: none;
  }

  @media (max-width: 639px) {
    display: none;
  }
}

.leftbar__overlay {
  /* Fixed so it can rise above the fixed bottom nav and align to viewport edge */
  position: fixed;
  bottom: calc(var(--bottom-nav-height) + env(safe-area-inset-bottom, 0px) + 8px);
  right: 8px;
  background: var(--app-card-bg);
  border: 1.5px solid var(--surface-border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.24);
  border-radius: 8px;
  padding: 8px 0;
  z-index: 1100;
  /* Above the bottom nav (1000) */

  &-item {
    height: 36px;
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--foreground-primary);
    cursor: pointer;
    padding: 0 16px;
    box-sizing: border-box;
  }

  &-item:hover {
    background: var(--background-secondary);
  }
}

// .leftbar-desktop-anim {
//   @media (min-width: 640px) {
//     transition: margin-left 0.1s cubic-bezier(0.4, 0, 0.2, 1);
//     margin-left: 40px;
//   }
//   &--shifted {
//     @media (min-width: 640px) {
//       margin-left: -30px;
//     }
//   }
// }

@keyframes bellShake {

  0%,
  100% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(-10deg);
  }

  20% {
    transform: rotate(10deg);
  }

  30% {
    transform: rotate(-10deg);
  }

  40% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(-5deg);
  }

  60% {
    transform: rotate(5deg);
  }

  70% {
    transform: rotate(-5deg);
  }

  80% {
    transform: rotate(5deg);
  }

  90% {
    transform: rotate(0deg);
  }
}

.bell-shake {
  animation: bellShake 0.5s ease-in-out;
}
</style>
